var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnabledAccDeletedPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#9230C5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.455 9.37a.208.208 0 0 0-.046-.355L9.296 8.54a.21.21 0 0 1-.127-.192v-.946a.21.21 0 0 1 .062-.147c.438-.519.67-1.18.65-1.859a.21.21 0 0 1 .073-.147 1.56 1.56 0 0 0 .448-1.167 1.317 1.317 0 0 0-.264-.846.21.21 0 0 1-.029-.22c.212-.45.259-.959.131-1.439C9.956.42 8.538.01 7.41.01a3.127 3.127 0 0 0-2.636 1.103.21.21 0 0 1-.177.098.893.893 0 0 0-.75.313c-.31.41-.088.976.147 1.443a.21.21 0 0 1-.039.24c-.05.051-.095.107-.135.167a1.47 1.47 0 0 0-.217.802 1.27 1.27 0 0 0 .531 1.11.207.207 0 0 1 .098.161 2.64 2.64 0 0 0 .704 1.813c.043.039.067.094.067.152v.935c0 .083-.05.159-.126.192l-3.28 1.406C.536 10.4.383 11.365.173 12.7c-.046.3-.098.626-.167.983a.417.417 0 0 0 .412.492h7.328a.208.208 0 0 0 .207-.189 6.652 6.652 0 0 1 2.501-4.617z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.586 9.176a5.417 5.417 0 1 0 5.417 5.417 5.423 5.423 0 0 0-5.417-5.417zm2.917 6.25h-5.834a.833.833 0 0 1 0-1.666h5.834a.833.833 0 0 1 0 1.666z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnabledAccDeletedPeople);
export default __webpack_public_path__ + "static/media/enabled-acc-deleted-people.c103d4bf.svg";
export { ForwardRef as ReactComponent };